import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {

    auth: {

        clientId: '5dbeff8b-e73c-49bf-b9ab-1c2851b51ab3',
        authority: 'https://login.microsoftonline.com/74c284ca-5687-49b1-89ee-8c08e3e6dba1',
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
    },

    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
    },

    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
}
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [
        "User.Read",
        "Contacts.Read",
    ],
    state: ""
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphMePhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo",
};
